import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

window.addEventListener("error", (event) => {
  if (event?.message?.includes("ResizeObserver loop completed with undelivered notifications")) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return false;
  }
}, true);

const originalConsoleError = console.error;
console.error = (...args) => {
  if (String(args?.[0] || "").includes("ResizeObserver loop completed with undelivered notifications")) return;
  originalConsoleError(...args);
};

window.addEventListener("unhandledrejection", (event) => {
  if (String(event?.reason || "").includes("ResizeObserver loop completed with undelivered notifications")) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
